const footer = () => {
  if ($(window).width() < 990) {
    $("footer .titolo-widget-sidebar").click(function () {
      if ($(this).find(".toggler").length) $(this).nextAll("div").slideToggle();
    });
    $("footer .toggler").each(function () {
      $(this).parent(".titolo-widget-sidebar").nextAll().hide();
    });
  }

  const loghiSection = document.querySelector(".loghi__section");
  const copyright = document.querySelector(".copyright__section");
  const siteBtn = document.querySelector(".site-switcher__btn");

  if (siteBtn) {
    ScrollTrigger.create({
      trigger: copyright,
      start: "top bottom",
      end: "bottom bottom",
      onEnter: () => {
        siteBtn.classList.add("lower");
      },
      onLeaveBack: () => {
        siteBtn.classList.remove("lower");
      },
    });
  }

  if (loghiSection && copyright) {
    ScrollTrigger.create({
      trigger: copyright,
      start: "top bottom",
      end: "bottom bottom",
      onEnter: () => {
        loghiSection.classList.add("snapped");
      },
      onLeaveBack: () => {
        loghiSection.classList.remove("snapped");
      },
    });
  }
};

export default footer;
